// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"1a5b7f532f4ea402","6831":"a61539eda955d38b","8503":"e561693714b61897","9683":"a1609ec96cb0b502"}[chunkId] + ".js";
};